import { createSelector } from '@reduxjs/toolkit'
import { BookingAvailability } from '@/store/bookingAvailabilitySlice'
import { servicesSlice } from '@/store/servicesSlice'
import { cartSlice } from '..'

export const availableFeaturedServicesSelector = createSelector(
  [
    servicesSlice.selectors.featuredServices,
    servicesSlice.selectors.data,
    cartSlice.selectors.cartReservations,
    cartSlice.selectors.selectedBookingType,
  ],
  (featuredServices, services, cartReservations, selectedBookingType) => {
    if (selectedBookingType === BookingAvailability.TICKETS) {
      return featuredServices
    }
    const extraFeaturedServices = services?.extraFeaturedServices
    // FIXME: cartReservations are not-nullable but somehow it's arriving undefined
    const cartReservationsSectors =
      cartReservations?.map((reservation) => reservation.sectorId) ?? []
    return extraFeaturedServices?.filter((service) =>
      service.sectors.some((sector) => cartReservationsSectors.includes(sector))
    )
  }
)
